/**
 * Created by zhaoyu on 2018/2/2.
 * 用户信息
 */
import { post, post2, postSettle } from 'utils/post';

// 获取商品信息
export function getGoodsList(data) {
  return post2('/api/goods/goodsInfo/list', data)
}

// 埋点
export function track(data) {
  return post2('/api/userBehaviors', data)
}

// 获取评论咨询数据
export function getCommentList(data) {
  return post2('/api/goods/comment/list', data)
}

// 判断商品是否能发货接口
export function isDelivery(data) {
  return post2('/api/goods/isDelivery', data)
}

// 获取销售记录
export function getSaleList(data) {
  return post2('/api/goods/sales/list', data)
}

// 收藏商品
export function favoriteAdd(data) {
  return post2('/api/collection/save', data)
}

// 取消收藏收藏商品
export function favoriteDelete(data) {
  return post2('/api/collection/delete', data)
}

// 获取店铺信息
export function getShopsInfo(data) {
  return post2('/api/store/store_detail', data)
}

// 获取店铺推荐商品
export function getGoodsTag(data) {
  return post2('/api/goods/tagGoods/list', data)
}

// 提交商品评论
export function addComment(data) {
  return post2('/api/member/comment/save', data)
}

// 商品是否能评论
export function getGoodsCommentInfo(data) {
  return post2('/api/member/comment/isComment', data)
}

// 通过店铺id查询所有商品分类
export function getAllCatList(data) {
  return post2('/pc/store/getStoreCategoryByStoreId', data)
}

// 搜索爆款专区商品
export function couponActive(data) {
  return post2('/api/goods/couponActive', data);
}


export function getUserBankInfo(data) {
  return post2('/api/personal/account/Information', data)
}


// WEBPACK FOOTER //
// ./src/api/goods.js